import React from "react";
import { useHrStyles } from "../../Context/HRContext";
import "./Image.css";

export default function Image() {
  const hrStyles = useHrStyles();

  return (
    <div className="home-image-container">
      <img
        src="/assets/images/homeimage.jpg"
        alt="Home"
        className="home-image"
      />
      <div className="beamtext">
        <p className="headtext">Building</p>
        <p className="headtext">Engineering</p>
        <p className="headtext">Architecture</p>
        <p className="headtext">Management</p>
        <p className="headtext">Services</p>
      </div>
      <hr style={hrStyles} />
    </div>
  );
}
